var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4"},[_vm._v(" There are no roulettes. Use the \"Create New\" button on the left to create your first roulette. ")])}
var staticRenderFns = []

export { render, staticRenderFns }